import Alert from 'react-bootstrap/Alert';
import Container from 'react-bootstrap/Container';
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';
import CreateUser from './CreateUser';
import ViewUsers from './ViewUsers';

const isDevelopment =
  process.env.REACT_APP_API_PREFIX?.includes('devapi.bocreate-dev.co.uk') ??
  false;

const isInteractive =
  process.env.REACT_APP_USER_MGMT_INTERACTIVE?.toLowerCase() === 'true';

const UserManagement = () => (
  <Container className="my-4">
    {isDevelopment && (
      <Alert variant="warning" className="mb-3 fw-semibold text-center">
        Read-only Mode: No Changes allowed to ensure Production Users are not affected
      </Alert>
    )}
    <div
      style={{
        pointerEvents: isInteractive ? 'auto' : 'none',
        opacity: isDevelopment ? 0.6 : 1,
      }}
    >
      <Tabs variant="tabs" defaultActiveKey="view_users">
        <Tab eventKey="view_users" title="View Users">
          <ViewUsers />
        </Tab>
        <Tab eventKey="create_user" title="Create a New User">
          <CreateUser />
        </Tab>
      </Tabs>
    </div>
  </Container>
);

export default UserManagement;
